export const currentCountry = () => {
    const { host } = location;
    const splitHost = host.split('.');
    return splitHost.includes('dev') || host.lastIndexOf('localhost') > -1
        ? 'dev'
        : splitHost.pop();
};

export const configCountry = () => countries[currentCountry()];

export const countries = {
    co: {
        country_code: 'co',
        lat: 4.6755234,
        lng: -74.0498693,
        web_property_id: 'UA-64467188-1',
        extrenal_api: 'https://services.grability.rappi.com',
        base_img: 'https://images.rappi.com/cms-web/images',
        domain: 'https://gemahub.rappi.com'
    },
    dev: {
        country_code: 'co',
        lat: 4.6755234,
        lng: -74.0498693,
        web_property_id: 'UA-64467188-1',
        extrenal_api: 'https://microservices.dev.rappi.com',
        base_img: 'https://images.dev.rappi.com',
        domain: 'https://gemahub.dev.rappi.com'
    },
    uy: {
        country_code: 'uy',
        lat: -34.91132,
        lng: -56.166161,
        web_property_id: 'UA-64467188-9',
        extrenal_api: 'https://services.rappi.com.uy',
        base_img: 'https://images.rappi.com/cms-web/images',
        domain: 'https://gemahub.rappi.com.uy'
    },
    pe: {
        country_code: 'pe',
        lat: -12.1453636,
        lng: -77.0219466,
        web_property_id: 'UA-64467188-11',
        extrenal_api: 'https://services.rappi.pe',
        base_img: 'https://images.rappi.com/cms-web/images',
        domain: 'https://gemahub.rappi.com.pe'
    },
    mx: {
        country_code: 'mx',
        lat: 19.425877,
        lng: -99.164086,
        web_property_id: 'UA-64467188-4',
        extrenal_api: 'https://services.mxgrability.rappi.com',
        base_img: 'https://images.rappi.com/cms-web/images',
        domain: 'https://gemahub.rappi.com.mx'
    },
    ec: {
        country_code: 'ec',
        lat: -0.174505,
        lng: -78.48359,
        web_property_id: 'UA-64467188-22',
        extrenal_api: 'https://services.rappi.com.ec',
        base_img: 'https://images.rappi.com/cms-web/images',
        domain: 'https://gemahub.rappi.com.ec'
    },
    cr: {
        country_code: 'cr',
        lat: 9.935697,
        lng: -84.1483645,
        web_property_id: 'UA-64467188-23',
        extrenal_api: 'https://services.rappi.co.cr',
        base_img: 'https://images.rappi.com/cms-web/images',
        domain: 'https://gemahub.rappi.co.cr'
    },
    cl: {
        country_code: 'cl',
        lat: -33.4147039,
        lng: -70.6023703,
        web_property_id: 'UA-64467188-8',
        extrenal_api: 'https://services.rappi.cl',
        base_img: 'https://images.rappi.com/cms-web/images',
        domain: 'https://gemahub.rappi.cl'
    },
    br: {
        country_code: 'br',
        lng: -46.674584,
        lat: -23.584293,
        web_property_id: 'UA-64467188-6',
        extrenal_api: 'https://services.rappi.com.br',
        base_img: 'https://images.rappi.com/cms-web/images',
        domain: 'https://gemahub.rappi.com.br'
    },
    ar: {
        country_code: 'ar',
        lat: -34.5887308,
        lng: -58.4302191,
        web_property_id: 'UA-64467188-7',
        extrenal_api: 'https://services.rappi.com.ar',
        base_img: 'https://images.rappi.com/cms-web/images',
        domain: 'https://gemahub.rappi.com.ar'
    },
};
